export const esViewDishes = {
  navbarButton: "Ver platillos publicados",
  emptyList: "No hay platillos disponibles",
  cleanFilters: "Limpiar filtros",
  verifyLinkIsCorrect: "Verifica que el link es correcto",
  noDescription: "Sin descripción",
  noEnglishTranslation: "Sin traducción al inglés",
  noSpanishTranslation: "Sin traducción al español",
};
